<template>
  <div class="reputation-widget" v-bind:class="{ dark: theme === 'dark' }">
    <div class="header">
      <div class="top-image">
        <img v-if="theme !== 'dark'" src="../assets/guestflip-logo-light.png" />
        <img v-if="theme === 'dark'" src="../assets/guestflip-logo-dark.png" />
      </div>
      <div class="info-tooltip" v-on:click="openModal()">
        <img src="../assets/info-tooltip.png" />
      </div>
    </div>
    <div class="main-body">
      <div class="rating">
        <span class="hotel-rating">{{
          stats.averageRating
            ? Number.parseFloat(stats.averageRating)
                .toFixed(1)
                .toString()
                .replace(".", ",")
                .replace(",0", "")
            : 0
        }}</span>
        <span class="base-rating">/ 5</span>
      </div>
      <div class="stars">
        <div class="rating-caption">
          <div v-if="stats.averageRating >= 4">Awesome</div>
          <div v-else-if="stats.averageRating >= 3">Good</div>
          <div v-else-if="stats.averageRating >= 2">Satisfactory</div>
          <div v-else></div>
        </div>
        <div class="rating-stars">
          <img src="../assets/star.png" v-if="stats.averageRating >= 1" />
          <img src="../assets/star-half.png" v-if="stats.averageRating < 1" />
          <img src="../assets/star.png" v-if="stats.averageRating >= 2" />
          <img
            src="../assets/star-half.png"
            v-if="(stats.averageRating < 2) & (stats.averageRating > 1)"
          />
          <img src="../assets/star.png" v-if="stats.averageRating >= 3" />
          <img
            src="../assets/star-half.png"
            v-if="(stats.averageRating < 3) & (stats.averageRating > 2)"
          />
          <img src="../assets/star.png" v-if="stats.averageRating >= 4" />
          <img
            src="../assets/star-half.png"
            v-if="(stats.averageRating < 4) & (stats.averageRating > 3)"
          />
          <img src="../assets/star.png" v-if="stats.averageRating >= 5" />
          <img
            src="../assets/star-half.png"
            v-if="(stats.averageRating < 5) & (stats.averageRating > 4)"
          />
        </div>
      </div>
    </div>
    <div class="footer">
      {{
        stats.totalReviews
          ? Number.parseInt(stats.totalReviews)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, "$&,")
              .replace(".00", "")
          : 0
      }}
      Reviews
    </div>
  </div>
</template>

<script>
export default {
  name: "ReputationWidget",
  props: ["data", "widgetId", "theme"],
  data: function () {
    return {
      stats: {
        totalReviews: 0,
        averageRating: 0,
      },
    };
  },
  methods: {
    openModal() {
      const urlParams = new URLSearchParams(window.location.search);
      const iframeID = urlParams.get("iframeID");

      window.top.postMessage(
        { event: "openModal", id: iframeID + "-modal" },
        "*"
      );
    },
  },
  async mounted() {
    this.stats = this.data.stats;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Open+Sans");

.reputation-widget {
  background: white;
  font-family: "Open Sans", sans-serif;
  display: flex;
  flex-direction: column;
  padding: 20px;
  width: 210px;
  height: 108px;
  border: 1px #e9e9eb solid;
  border-radius: 5px;
  font-weight: bold;
  margin-right: auto;
  margin-left: auto;
}
.reputation-widget.dark {
  background: #212b3c;
  border-color: #212b3c;
}
.reputation-widget > .header {
  flex: 100%;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-height: 50px;
  margin-bottom: 5px;
}
.reputation-widget > .main-body {
  flex: 100%;
  display: flex;
  align-items: flex-end;
}
.reputation-widget > .footer {
  flex: 100%;
  display: flex;
  align-items: flex-end;
}
.reputation-widget > .header > .top-image,
.reputation-widget > .header > .info-tooltip {
  flex: 50%;
}
.reputation-widget > .header > .info-tooltip {
  text-align: right;
  cursor: pointer;
}
.reputation-widget > .main-body > .rating,
.reputation-widget > .main-body > .stars {
  flex: 50%;
}
.reputation-widget > .main-body > .stars {
  text-align: left;
}
.reputation-widget > .main-body > .stars .rating-caption {
  color: #9c9da9;
  font-size: 12px;
  padding-bottom: 4px;
}
.reputation-widget > .main-body .base-rating {
  padding-left: 5px;
  font-size: 20px;
}
.reputation-widget.dark > .main-body .base-rating {
  color: #484b60;
}
.reputation-widget > .main-body > .stars img {
  padding: 0 3px;
}

.reputation-widget > .main-body .hotel-rating {
  font-size: 40px;
  color: #00afef;
}
.reputation-widget.dark > .footer {
  color: white;
}
</style>
